import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

const SITECORE_BLANK_DATE = '0001-01-01T00:00:00Z';

const parseAllowedRoutes = value => {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.map(item => item?.fields?.route?.value);
};

const getCurrentRouteMatches = pathname => {
  if (!pathname) {
    return [];
  }
  let trimmed = pathname;
  let start = 0;
  while (start < trimmed.length && trimmed.charAt(start) === '/') {
    start += 1;
  }
  let end = trimmed.length;
  while (end > start && trimmed.charAt(end - 1) === '/') {
    end -= 1;
  }
  trimmed = trimmed.slice(start, end);
  if (!trimmed) {
    return [''];
  }
  const segments = trimmed.split('/');
  const matches = [segments[segments.length - 1]];
  for (let i = 0; i < segments.length; i += 1) {
    matches.push(segments.slice(i).join('/'));
  }
  return matches;
};

const Banner = ({ fields }) => {
  const location = useLocation();

  if (!fields?.message?.value) {
    return null;
  }

  const { startDate, expiryDate, allowedRoutes } = fields;
  const now = new Date();

  const allowed = parseAllowedRoutes(allowedRoutes);
  if (allowed.length > 0) {
    const currentMatches = getCurrentRouteMatches(location?.pathname);
    const isAllowed = allowed.some(route => currentMatches.includes(route));
    if (!isAllowed) {
      return null;
    }
  }

  if (
    !startDate?.value ||
    startDate.value === SITECORE_BLANK_DATE ||
    !expiryDate?.value ||
    expiryDate.value === SITECORE_BLANK_DATE
  ) {
    return null;
  }

  const start = new Date(startDate.value);
  if (now < start) {
    return null;
  }

  const expiry = new Date(expiryDate.value);
  if (now > expiry) {
    return null;
  }

  return (
    <div className="vds-full-width-banner" data-testid={fields.testid?.value}>
      <div className="vds-full-width-banner__inner">
        <div className="vds-full-width-banner__body">
          <RichText field={fields.message} />
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  fields: PropTypes.shape({
    message: PropTypes.shape({ value: PropTypes.string }),
    testid: PropTypes.shape({ value: PropTypes.string }),
    startDate: PropTypes.shape({ value: PropTypes.string }),
    expiryDate: PropTypes.shape({ value: PropTypes.string }),
    allowedRoutes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        fields: PropTypes.shape({
          route: PropTypes.shape({ value: PropTypes.string }),
        }),
      })
    ),
  }),
};

export default Banner;
